import { connect } from 'react-redux';
import Login from './Login';
import { getDecryptedMfaTempData } from '../../../utils/cookieUtils';
import { 
    getLoginRequest, 
    fetchLogoRequest, 
    resetErrorMesage 
} from '../../../store/actions/auth.actions';
import {
    logo,
    error, 
    loginInProgress, 
    mfaRequired,
    mfaSetupRequired,
    passwordResetRequired 
} from '../../../store/selectors/auth.selector';

const mapStateToProps = (state) => { 
    const authError = error(state);
    const isLoading = loginInProgress(state);
    const getLogo = logo(state);
    const mfaTempData = getDecryptedMfaTempData();
    const isMfaRequired = mfaTempData && mfaRequired(state);
    const isMfaSetupRequired = mfaSetupRequired(state);
    const isPasswordResetRequired = passwordResetRequired(state);

    return { authError, isLoading, getLogo, isMfaRequired, isMfaSetupRequired , isPasswordResetRequired};
 };

 const mapDispatchToProps = { loginRequest: getLoginRequest, fetchLogoRequest, resetErrorMesage };

export default connect(mapStateToProps, mapDispatchToProps)(Login);